import { DefaultEffects, IButtonStyles } from "@fluentui/react";

//#region PRIMARY

export const primaryButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: '1.5rem',
        fontWeight: 700,
        backgroundColor: "#2A7DE1",
        color: "white",
        border: "none",
        width: "100%",
        height: "4rem",
        borderRadius: '5px',
        boxShadow: DefaultEffects.elevation16,
    },
    icon: {
        fontSize: '2rem',
    }
};

export const xxlPrimaryButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(1.4rem, 2.5vw, 1.5rem)',
        fontWeight: 700,
        backgroundColor: "#2A7DE1",
        color: "white",
        border: "none",
        width: "100%",
        height: 'clamp(3.2rem, 2.5vw, 3.5rem)',
        borderRadius: '5px',
        boxShadow: DefaultEffects.elevation16,
    },
    icon: {
        fontSize: 'clamp(1.8rem, 2.5vw, 2rem)',
    }
};

export const xlPrimaryButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(1.3rem, 2.5vw, 1.4rem)',
        fontWeight: 700,
        backgroundColor: "#2A7DE1",
        color: "white",
        border: "none",
        width: "100%",
        height: 'clamp(3rem, 2.5vw, 3.2rem)',
        borderRadius: '5px',
        boxShadow: DefaultEffects.elevation16,
    },
    icon: {
        fontSize: 'clamp(1.7rem, 2.5vw, 1.8rem)',
    }
};

export const lgPrimaryButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(1.2rem, 2.5vw, 1.3rem)',
        fontWeight: 700,
        backgroundColor: "#2A7DE1",
        color: "white",
        border: "none",
        width: "100%",
        height: 'clamp(2.8rem, 2.5vw, 3rem)',
        borderRadius: '5px',
        boxShadow: DefaultEffects.elevation16,
    },
    icon: {
        fontSize: 'clamp(1.6rem, 2.5vw, 1.7rem)',
    }
};

export const mdPrimaryButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(1rem, 2.3vw, 1.1rem)',
        fontWeight: 700,
        backgroundColor: "#2A7DE1",
        color: "white",
        border: "none",
        width: "100%",
        height: 'clamp(2.5rem, 2.5vw, 2.8rem)',
        borderRadius: '5px',
        boxShadow: DefaultEffects.elevation16,
    },
    icon: {
        fontSize: 'clamp(1rem, 2.3vw, 1.1rem)',
    }
};

export const smPrimaryButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.8rem, 2.2vw, 0.9rem)',
        fontWeight: 700,
        backgroundColor: "#2A7DE1",
        color: "white",
        border: "none",
        width: "100%",
        height: 'clamp(2rem, 2.5vw, 2.5rem)',
        borderRadius: '5px',
        boxShadow: DefaultEffects.elevation16,
    },
    icon: {
        fontSize: 'clamp(0.8rem, 2.2vw, 0.9rem)',
    }
};

//#endregion PRIMARY

//#region DEFAULT

export const defaultButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: '1.5rem',
        fontWeight: 700,
        backgroundColor: "#FFFFFF",
        color: "#323130",
        width: "100%",
        height: "4rem",
        borderRadius: '5px',
        boxShadow: DefaultEffects.elevation4,
    },
    icon: {
        fontSize: '2rem',
        color: "#323130",
    }
};

export const xxlDefaultButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(1.4rem, 2.5vw, 1.5rem)',
        fontWeight: 700,
        backgroundColor: "#FFFFFF",
        color: "#323130",
        width: "100%",
        height: 'clamp(3.2rem, 2.5vw, 3.5rem)',
        borderRadius: '5px',
        boxShadow: DefaultEffects.elevation4,
    },
    icon: {
        fontSize: 'clamp(1.8rem, 2.5vw, 2rem)',
        color: "#323130",
    }
};

export const xlDefaultButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(1.3rem, 2.5vw, 1.4rem)',
        fontWeight: 700,
        backgroundColor: "#FFFFFF",
        color: "#323130",
        width: "100%",
        height: 'clamp(3rem, 2.5vw, 3.2rem)',
        borderRadius: '5px',
        boxShadow: DefaultEffects.elevation4,
    },
    icon: {
        fontSize: 'clamp(1.7rem, 2.5vw, 1.8rem)',
        color: "#323130",
    }
};

export const lgDefaultButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(1.2rem, 2.5vw, 1.3rem)',
        fontWeight: 700,
        backgroundColor: "#FFFFFF",
        color: "#323130",
        width: "100%",
        height: 'clamp(2.8rem, 2.5vw, 3rem)',
        borderRadius: '5px',
        boxShadow: DefaultEffects.elevation4,
    },
    icon: {
        fontSize: 'clamp(1.6rem, 2.5vw, 1.7rem)',
        color: "#323130",
    }
};

export const mdDefaultButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(1rem, 2.3vw, 1.1rem)',
        fontWeight: 700,
        backgroundColor: "#FFFFFF",
        color: "#323130",
        width: "100%",
        height: 'clamp(2.5rem, 2.5vw, 2.8rem)',
        borderRadius: '5px',
        boxShadow: DefaultEffects.elevation4,
    },
    icon: {
        fontSize: 'clamp(1rem, 2.3vw, 1.1rem)',
        color: "#323130",
    }
};

export const smDefaultButtonStyles: IButtonStyles = {
    root: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.8rem, 2.2vw, 0.9rem)',
        fontWeight: 700,
        backgroundColor: "#FFFFFF",
        color: "#323130",
        width: "100%",
        height: 'clamp(2rem, 2.5vw, 2.5rem)',
        borderRadius: '5px',
        boxShadow: DefaultEffects.elevation4,
    },
    icon: {
        fontSize: 'clamp(0.8rem, 2.2vw, 0.9rem)',
        color: "#323130",
    }
};

//#endregion DEFAULT